import { api } from '../api';
import { useMutation, UseMutationResult, useQuery, UseQueryResult } from 'react-query';
import { WorkpaperExport, WorkpaperExportEnum, WorkpaperStatusEnum } from '../types/workpaper';
import { AxiosError } from 'axios';
import { isMock } from '../utilities/is-mock';

type GetWorkpaperExportResponse = {
    workpaperExport: WorkpaperExport;
};
type UseWorkpapersConfig = {
    search: string;
    sort: string;
    filter: string;
    page?: number;
    limit?: number;
    enabled?: boolean;
    status?: string;
    assigned?: string;
};

async function download({ search, sort, filter, status, assigned }: UseWorkpapersConfig): Promise<void> {
    try {
        const query = `${filter}&${sort}&search=${encodeURIComponent(search)}`;

        const response = await api.get(`/workpapers/download?${query}`, {
            responseType: 'blob',
            headers: { Accept: 'text/csv' },
            params: { status, assigned },
        });
        // Create URL and trigger download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'workpaper.csv');
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        throw new Error((error as AxiosError).response?.data?.message || 'Failed to download CSV. Please try again.');
    }
}

export function useWorkpaperCsvExport({
    search,
    sort,
    filter,
    status,
    assigned,
}: UseWorkpapersConfig): UseMutationResult<void, AxiosError, void, unknown> {
    return useMutation(() => download({ search, sort, filter, status, assigned }));
}
